import * as actions from '../../action-creators';
import { api } from '../../lib';

const { loadCurrentAuthentication, setUiStateValue, UI_STATE_KEY_USER_APP_IN_TERMINAL_MODE } = actions;

export const enterUserApp = (dispatch) => async () => {
  await dispatch(loadCurrentAuthentication({ api }));
  return dispatch(setUiStateValue({ key: UI_STATE_KEY_USER_APP_IN_TERMINAL_MODE, value: true }));
};
